"use strict";

var path = require('path');

var root = path.join(__dirname);

var config = {
    rootDir:                root,
    // Targets ========================================================
    serveDir:               path.join(root, '.serve'),
    distDir:                path.join(root, 'dist'),
    clientManifestFile:     'manifest.webpack.json',
    clientStatsFile:        'stats.webpack.json',

    // Source Directory ===============================================
    srcDir:                 path.join(root, 'src'),
    srcServerDir:           path.join(root, 'server'),

    // Site Config ====================================================
    siteTitle:              'The Monster Kings',
    siteDescription:        'Default Dashboard ready for Development',
    siteCannonicalUrl:      'http://localhost:4100',
    siteKeywords:           'react dashboard seed bootstrap',
    scssIncludes:           []
}

module.exports = config;
